import { Currency } from '../enums/currency';
import { CurrencySubTypes } from '../enums/currency-sub-types';

/** Maliyet detayında hangi işlemlerin isteneceği. */
export enum ExchangeCostDirection {
  All = 0,
  /** Yalnızca alışlar: döviz dükkâna giriyor. */
  Purchase = 1,
  /** Yalnızca satışlar: döviz dükkândan çıkıyor. */
  Sale = 2,
}

/**
 * Tek bir dövizin maliyet özeti. Tarih aralığı işlemin anlaşma tarihine uygulanır; stok ve
 * güncel maliyet aralığın sonuna kadarki bütün hareketlerden gelir.
 */
export interface ExchangeCostDetail {
  currency: Currency;
  subType?: CurrencySubTypes;
  /** Ortalama birim maliyet, kur gibi görüntü biçiminde. 0 = bilinmiyor. */
  costTL: number;
  costUSD: number;
  costHAS: number;
  /** Güncel maliyeti oluşturan son alışın tarihi. */
  costDate?: string;
  /** Alım/satım işlemlerinden izlenen stok: alışlar eksi satışlar. */
  stock: number;
  /** Şube kasalarındaki gerçek bakiye. Tahsilat ve transfer buraya yansır, stoğa yansımaz. */
  caseBalance: number;
  /** Kasa bakiyesi eksi defter stoğu. Sıfırdan farkı alım/satım dışından gelmiştir. */
  stockDifference: number;
  purchaseCount: number;
  purchaseAmount: number;
  saleCount: number;
  saleAmount: number;
  /** Aralıktaki satışlarda gerçekleşen kâr. */
  profitTL: number;
  profitUSD: number;
  profitHAS: number;
  /** Bu birimin işlemlerinin piyasaya göre toplam farkı, has cinsinden. Kâr değildir. */
  marketDifferenceHAS: number;
  /** Değeri bilinmeyen işlem sayısı; bunların maliyeti elle girilebilir. */
  unknownValueCount: number;
  /** Maliyeti henüz yeni yöntemle hesaplanmamış işlem sayısı. */
  unprocessedCount: number;
  totalCount: number;
  firstDate?: string;
  lastDate?: string;
}

export interface ExchangeCostDetailRequest {
  currency: Currency;
  subType?: CurrencySubTypes;
  beginDate?: Date;
  endDate?: Date;
}

export interface ExchangeCostDetailListRequest extends ExchangeCostDetailRequest {
  pageIndex: number;
  itemPerPage: number;
  direction: ExchangeCostDirection;
}
